<template>
  <div class="card-panel" :class="{ 'showPopup': pilotNavOpen === 'card' }">
    <div class="card-header">
      <div class="lable">知识卡片</div>

      <svg class="icon-svg icon-close" @click="setPilotNav('')">
        <use xlink:href="#icon-close" />
      </svg>
    </div>
    <div class="review-btn" v-if="reviewCards.length">
      <span @click="isOpenReview = true; setPilotNav('')">开始复习</span>
    </div>
    <div class="cards">
      <div class="card" v-for="card in cards" :key="card.uid">
        <div class="info text">
          {{ card.text }}
          <svg class="icon-svg icon delete-btn" @click="deleteCard(card.uid)">
            <use xlink:href="#icon-delete-line" />
          </svg>
        </div>
        <div class="info quote">引文：{{ card.quote }}</div>
        <div class="info meaning">释文：{{ card.meaning }}</div>
        <div class="state">
          <div class="state-item" 
            :class="{ 'selected': card.state === item }" 
            v-for="item in 4" 
            :key="item" 
            @click="updateCardState(card.uid, item)"
          >{{ item }}</div>
          <div class="state-item finish" :class="{ 'selected': card.state === 99 }" key="finish" @click="updateCardState(card.uid, 99)">
            <span>已记住</span>
          </div>
        </div>
      </div>
      <div class="empty" v-if="!cards.length">
        你还未添加过知识卡片！
      </div>
    </div>

    <div class="review" v-if="isOpenReview">
      <div class="review-card" v-if="reviewCards[reviewIndex]">
        <div class="review-card-content" 
          :class="{
            'show': index === reviewIndex,
            'prev': index < reviewIndex,
            'next-1': index === reviewIndex + 1,
            'next-2': index === reviewIndex + 2,
            'next-more': index > reviewIndex + 2,
          }"
          v-for="(card, index) in reviewCards" 
          :key="card.uid"
        >
          <div class="front" key="front" :style="{ transform: `rotateY(${reviewFlipState[index] === 'front' ? 0 : -180}deg)` }">
            <svg class="icon-svg review-close" @click="isOpenReview = false">
              <use xlink:href="#icon-close" />
            </svg>
            <div class="voice" @click="textToVoice(card.text)">
              <svg class="icon-svg icon">
                <use xlink:href="#icon-sound" />
              </svg>
            </div>
            <div class="text">{{ card.text }}</div>
            <div class="quote">{{ card.quote }}</div>
            <div class="flip" @click="flip()">翻转</div>
          </div>
          <div class="back" key="back" :style="{ transform: `rotateY(${reviewFlipState[index] === 'front' ? 180 : 0}deg)` }">
            <svg class="icon-svg review-close" @click="isOpenReview = false">
              <use xlink:href="#icon-close" />
            </svg>
            <div class="progress">
              <div class="info" :style="{ left: (reviewIndex + 1) / reviewCards.length * 100 + '%' }">{{ reviewIndex + 1 }}/{{ reviewCards.length }}</div>
              <div class="bar">
                <div class="bar-inner" :style="{ width: (reviewIndex + 1) / reviewCards.length * 100 + '%' }"></div>
              </div>
            </div>
            <div class="voice" @click="textToVoice(card.text)">
              <svg class="icon-svg icon">
                <use xlink:href="#icon-sound" />
              </svg>
            </div>
            <div class="text">{{ card.text }}</div>
            <div class="quote">{{ card.quote }}</div>
            <div class="meaning" v-if="card.meaning">{{ card.meaning }}</div>

            <div class="state">
              <div class="state-wrap">
                <div class="state-item" 
                  :class="{ 'selected': card.newState === item }" 
                  v-for="item in 4" 
                  :key="item" 
                  @click="updateReviewCards({ newState: item })"
                >{{ item }}</div>
                <div class="state-item finish" :class="{ 'selected': card.newState === 99 }" @click="updateReviewCards({ newState: 99 })">
                  <span>已记住</span>
                </div>
              </div>
              <div class="state-label">记忆等级</div>
            </div>

            <div class="next-btns">
              <div class="error">
                <div class="tooltip">
                  <h3>忘记也没关系</h3>
                  <p>我们将在下一组中再次尝试这个问题。我们的系统会调整每个问题的复习时间表，以帮助您记住所有的内容。</p>
                </div>
                <div class="next" @click="next(false)">
                  <svg class="icon-svg icon">
                    <use xlink:href="#icon-reset" />
                  </svg>
                  没记住
                </div>
              </div>
              <div class="next" @click="next(true)">
                <svg class="icon-svg icon">
                  <use xlink:href="#icon-right" />
                </svg>
                记住了
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapState } from 'vuex'
import api from '@/services'
import { Modal } from 'ant-design-vue'

export default {
  name: 'card-panel',
  data() {
    return {
      cards: [],
      reviewCards: [],
      reviewIndex: 0,
      reviewFlipState: [],
      isOpenReview: false,
      soundPlaying: false,
    }
  },
  computed: {
    ...mapState({
      userInfo: state => state.userInfo,
      currentClass: state => state.currentClass,
      pilotNavOpen: state => state.pilotNavOpen,
    }),
  },
  watch: {
    isOpenReview() {
      if(this.isOpenReview) {
        this.reviewIndex = 0
        this.reviewFlipState = new Array(this.reviewCards.length).fill('front')
      }
    },
  },
  mounted() {
    this.initData()
  },
  methods: {
    ...mapMutations({
      setPilotNav: 'pilotNavOpen',
    }),

    async initData() {
      const ret = await api.card.getCards({
        studentId: this.userInfo.PK_UserGuid,
        classId: this.currentClass.PK_ClassGuid,
      })
      if(ret.data) {
        this.cards = ret.data

        const timeMap = [1, 3, 7, 15]

        this.reviewCards = this.cards.filter(card => {
          if(card.state === 99) return false
          const timeDiff = (new Date() - new Date(card.lastLearnTime || card.createTime)) / 1000 / 60 / 60 / 24
          if(timeDiff <= timeMap[card.state]) return false
          return true
        }).map(card => ({
          uid: card.uid,
          text: card.text,
          quote: card.quote,
          meaning: card.meaning,
          state: card.state,
          newState: card.state,
          lastflag: card.lastflag,
        }))
      }
    },

    deleteCard(uid) {
      api.card.deleteCard(uid).then(() => {
        this.cards = this.cards.filter(card => card.uid !== uid)
        this.$emit('cardUpdated', { action: 'delete', uid })
      })
    },
    updateCardState(uid, state) {
      api.card.updateCard({
        uid,
        state,
      }).then(() => {
        this.cards = this.cards.map(card => {
          if(card.uid === uid) {
            return {
              ...card,
              state,
            }
          }
          return card
        })
        this.$emit('cardUpdated', { action: 'update', uid, props: { state } })
      })
    },

    updateReviewCards(props) {
      this.reviewCards = this.reviewCards.map((card, index) => {
        if(index === this.reviewIndex) {
          return {
            ...card,
            ...props,
          }
        }
        return card
      })
    },
    flip() {
      this.reviewFlipState = this.reviewFlipState.map((item, index) => {
        if(index === this.reviewIndex) return 'back'
        return 'front'
      })
    },
    next(flag) {
      this.updateReviewCards({ flag })

      const nextCard = this.reviewCards[this.reviewIndex + 1]
      if(nextCard) {
        this.reviewIndex = this.reviewIndex + 1
        return
      }
      Modal.success({
        title: '您已完成复习！',
        onOk: async () => {
          // 需要删除的清单
          const needDeleteIdList = this.reviewCards.filter(item => item.newState === -1).map(item => item.uid)

          // 需要修改的清单
          const needUpdateList = this.reviewCards.filter(item => item.newState !== -1).map(item => {
            let state = item.newState
            if(item.lastflag !== undefined && item.lastflag === item.flag) {
              if(item.flag === true) state += 1
              if(item.flag === false) state -= 1
            }
            if(state < 1) state = 1
            if(state > 4) state = 99

            return {
              uid: item.uid,
              state,
              lastflag: item.flag,
            }
          })

          if(needDeleteIdList.length) await api.card.deleteCards(JSON.stringify(needDeleteIdList))
          if(needUpdateList.length) await api.card.updateCards(needUpdateList)

          this.initData()

          this.isOpenReview = false
        },
      })
    },
    textToVoice(text) {
      if(this.soundPlaying) return
      api.tts.TTS(text).then(audio => {
        if(audio) {
          const audioNode = new Audio()
          audioNode.src = audio
          audioNode.play()

          this.soundPlaying = true
          audioNode.addEventListener('ended', () => this.soundPlaying = false)
        }
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.card-panel {
  position: fixed;
  top: 60px;
  right: -360px;
  box-shadow: $box-shadow;
  border-radius: 14px;
  background-color: #ffffff;
  z-index: 99;
  height: calc(100% - 70px);
  width: 340px;
  transition: all .3s ease;
  font-size: 16px;
  display: flex;
  flex-direction: column;

  &.showPopup {
    right: 16px;
  }

  .card-header {
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 8px 16px;
    color: #666;
    padding-bottom: 0;

    .lable {
      font-weight: 700;
      font-size: 18px;
      color: #333;
    }

    .icon-close {
      font-size: 22px;
      cursor: pointer;

      &:hover {
        color: #fdb8bc;
      }
    }
  }
}
.review-btn {
  height: 36px;
  padding: 0 16px;
  display: flex;
  align-items: center;
  justify-content: flex-end;

  span {
    background-color: #f98d99;
    color: #fff;
    border-radius: 6px;
    padding: 3px 12px;
    font-size: 12px;
    cursor: pointer;
  }
}
.cards {
  flex: 1;
  padding: 8px 16px;
  overflow: auto;

  .card {
    box-shadow: 4px 4px 12px #ccc;
    padding: 18px;
    border-radius: 10px;
    font-size: 14px;
    cursor: pointer;

    &:hover {
      box-shadow: 4px 4px 12px #aaa;

      .text .delete-btn {
        opacity: 1;
      }
    }

    & + .card {
      margin-top: 18px;
    }
  }
  .info {
    margin-bottom: 5px;

    &.text {
      font-weight: 700;
      font-size: 18px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 10px;
    }
    .delete-btn {
      font-size: 18px;
      color: #999;
      opacity: .5;
    }
  }
  .state {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 16px;
    position: relative;

    &::after {
      content: '';
      position: absolute;
      height: 2px;
      background-color: #eee;
      top: 50%;
      left: 10px;
      right: 10px;
      margin-top: -1px;
    }
    &::before {
      content: '';
      position: absolute;
      width: 0;
      height: 0;
      border-top: 4px solid transparent;
      border-bottom: 4px solid transparent;
      border-left: 6px solid #eee;
      border-right: 6px solid transparent;
      right: 26px;
    }
  } 

  .state-item {
    width: 32px;
    height: 32px;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 16px;
    background-color: #eee;
    border: 2px solid transparent;
    color: #333;
    font-size: 12px;
    position: relative;
    z-index: 2;
    cursor: pointer;

    &.finish span {
      zoom: .65;
    }

    &.selected {
      background-color: #fbb3bb;
      border: 2px solid #fff;
      color: #fff;
      position: relative;

      &::after {
        content: '';
        position: absolute;
        inset: -1px;
        background-color: transparent;
        outline: 1px solid #fbb3bb;
        z-index: -1;
        border-radius: 50%;
      }
    }
  }
}
.empty {
  font-size: 14px;
  font-style: italic;
  color: #ccc;
}

.review {
  position: fixed;
  inset: 0;
  background-color: rgba($color: #000, $alpha: .15);
  z-index: 999;

  .review-close {
    position: absolute;
    right: 15px;
    top: 15px;
    font-size: 24px;
    z-index: 99;
    cursor: pointer;
  }

  .review-card {
    position: absolute;
    inset: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    animation: bounceInDown .75s;
  }
  .review-card-content {
    width: 80%;
    height: 80%;
    max-width: 1200px;
    min-width: 800px;
    max-height: 660px;
    min-height: 560px;
    position: absolute;
    perspective: 5000px;
    transition: all 0.6s;

    &.show {
      z-index: 3;
    }
    &.prev {
      transform: translateY(200%) rotate(90deg);
      z-index: 3;
    }
    &.next-1 {
      transform: translateY(-32px) scale(0.95);
      z-index: 2;
    }
    &.next-2 {
      transform: translateY(-62px) scale(0.9);
      z-index: 1;
    }
    &.next-more {
      display: none;
    }
  }
  .front, .back {
    width: 100%;
    height: 100%;
    padding: 45px 50px 65px;
    border-radius: 16px;
    background-color: #fff;
    box-shadow: 0 0 20px #aaa;
    position: absolute;
    top: 0;
    left: 0;
    backface-visibility: hidden;
    transition: all 0.6s;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .progress {
      position: absolute;
      bottom: 30px;
      left: 0;
      right: 0;

      .bar {
        width: 100%;
        height: 4px;
        border-radius: 2px;
        background-color: #ddd;
        overflow: hidden;
      }
      .bar-inner {
        width: 0;
        height: 100%;
        background-color: #f98d99;
      }
      .info {
        width: 80px;
        color: #f98d99;
        text-align: center;
        position: absolute;
        left: 0;
        top: -28px;
        margin-left: -80px;
      }
    }

    .voice {
      font-size: 36px;
      color: #555;
      margin-left: 2px;
      display: flex;
      align-items: center;
      margin-bottom: 15px;
      cursor: pointer;

      &:hover {
        color: #f98d99;
      }
    }
    .text {
      font-weight: 700;
      font-size: 46px;
      color: #000;
    }
    .quote {
      font-size: 20px;
      color: #888;
      margin-top: 15px;
      word-wrap: break-word;
      overflow: hidden;
      text-overflow: ellipsis;
      font-style: italic;
      display: -webkit-box;
      -webkit-line-clamp: 3;
      -webkit-box-orient: vertical;
    }
    .meaning {
      max-height: 100px;
      font-size: 18px;
      color: #666;
      margin-top: 25px;
      padding: 6px 16px;
      background-color: #eee;
      border-radius: 10px;
      overflow: auto;
    }
    .flip {
      font-size: 16px;
      padding: 5px 44px;
      border-radius: 6px;
      background-color: #f98d99;
      color: #fff;
      border-radius: 6px;
      margin-top: 40px;
      cursor: pointer;
    }
    .state {
      width: 380px;
      margin-top: 45px;

      .state-wrap {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        position: relative;

        &::after {
          content: '';
          position: absolute;
          height: 2px;
          background-color: #eee;
          top: 50%;
          left: 10px;
          right: 10px;
          margin-top: -1px;
        }
        &::before {
          content: '';
          position: absolute;
          width: 0;
          height: 0;
          border-top: 4px solid transparent;
          border-bottom: 4px solid transparent;
          border-left: 6px solid #eee;
          border-right: 6px solid transparent;
          right: 44px;
        }
      }
      .state-label {
        text-align: center;
        margin-top: 5px;
        color: #aaa;
        font-size: 13px;
      }
    } 

    .state-item {
      width: 48px;
      height: 48px;
      border-radius: 50%;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 16px;
      background-color: #eee;
      border: 4px solid #fff;
      color: #333;
      font-size: 13px;
      position: relative;
      z-index: 2;
      cursor: pointer;

      &.finish span {
        font-size: 12px;
        zoom: .82;
      }

      &.selected {
        background-color: #fbb3bb;
        border: 4px solid #fff;
        color: #fff;
        position: relative;

        &::after {
          content: '';
          position: absolute;
          inset: -3px;
          background-color: transparent;
          outline: 2px solid #fbb3bb;
          z-index: -1;
          border-radius: 50%;
        }
      }
    }
    .next-btns {
      display: flex;
      justify-content: center;
      align-items: center;
      margin-top: 20px;

      .next {
        padding: 5px 30px;
        background-color: #eee;
        font-size: 15px;
        margin:  0 8px;
        border-radius: 6px;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;

        .icon {
          margin-right: 6px;
          font-size: 20px;
          transition: none;
        }

        &:hover {
          background-color: #f98d99;
          color: #fff;
        }
      }
      .error {
        position: relative;

        &:hover .tooltip {
          display: block;
        }

        .tooltip {
          width: 280px;
          color: #333;
          padding: 12px 18px;
          border-radius: 6px;
          box-shadow: 4px 4px 20px #ccc;
          position: absolute;
          bottom: 48px;
          left: -75px;
          z-index: 10;
          background-color: #fff;
          display: none;

          h3 {
            font-weight: 700;
            font-size: 17px;
            margin-bottom: 5px;
          }
          p {
            line-height: 1.375;
            font-size: 14px;
            margin-bottom: 0;
          }
        }
      }
    }
  }
}

@keyframes bounceInDown {
  from,
  60%,
  75%,
  90%,
  to {
    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
  }
  0% {
    opacity: 0;
    transform: translate3d(0, -3000px, 0);
  }
  60% {
    opacity: 1;
    transform: translate3d(0, 25px, 0);
  }
  75% {
    transform: translate3d(0, -10px, 0);
  }
  90% {
    transform: translate3d(0, 5px, 0);
  }
  to {
    transform: translate3d(0, 0, 0);
  }
}
</style>